import moment from 'moment-es6';
import transform from 'lodash-es/transform';
import store from '@app/plugins/vuex';
import momentTime from 'moment-timezone';

export function toUserDate(date) {
  return moment(date).format('L');
}

export function toUserDateWithTime(value) {
  if (value) {
    return moment(value).format('L LTS');
  } else {
    return '';
  }
}

/**
 * Переводит дату с учетом таймзоны аккаунта
 * Используется для задания формата в таблицах
 */
export function toAccountTimezoneDateWithTime(value) {
  if (value && moment(value).isValid()) {
    const timezoneCountry = store.getters['core/auth/user'].timezone;
    const date = momentTime.tz(value, timezoneCountry).format('DD.MM.YYYY hh:mm:ss');
    const timezoneOffset = momentTime.tz(timezoneCountry).format('Z');
    return date + ' UTC ' + timezoneOffset;
  } else {
    return '';
  }
}

/**
 * Нужен как хэлпер, для initSearchStateByPeriod
 * Используется для задания формата в DatePicker
 */
export function toFrontendDateWithTime(data) {
  return moment(data).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * Сейчас toFrontendDateWithTime === toBackendDateWithTime
 * Но есть вероятность, что бекенд поменяют формат входного значения,
 * И тогда можно будет заменить в одном месте.
 */
export function toBackendDateWithTime(data) {
  return moment(data).format('YYYY-MM-DD HH:mm:ss');
}

export function initSearchStateByPeriod(days = 6) {
  const start = moment().subtract(days, 'd').startOf('d');
  const end = moment().endOf('d');

  return {
    start: toFrontendDateWithTime(start),
    end: toFrontendDateWithTime(end)
  };
}

export function getCleanJSDatePeriod(days = 6) {
  const today = new Date();
  const xDaysAgo = new Date(today);
  xDaysAgo.setDate(today.getDate() - days);
  xDaysAgo.setHours(0, 0, 0, 0);
  const endOfDay = new Date(today);
  endOfDay.setHours(23, 59, 59, 999);
  return [xDaysAgo, endOfDay];
}

export function parseSearchStateByPeriod(period = { start: null, end: null }) {
  return transform(
    period,
    (result, value, key) => {
      const moment_value = moment(value);
      if (moment_value.isValid()) {
        result[key] = toBackendDateWithTime(value);
      } else {
        result[key] = null;
      }
    },
    {}
  );
}

export function daysUntilPaymentExpiration(activationDate) {
  const today = moment();
  const paymentDate = moment(activationDate);
  const paymentDay = paymentDate.date();

  let dateOfNextPayment = moment().date(paymentDay);
  // .hour(0).minute(0).second(0);

  if (today.date() > paymentDay) {
    dateOfNextPayment = dateOfNextPayment.add(1, 'month');
  }

  const timeDiff = dateOfNextPayment.diff(today, 'days');
  const diffDays = Math.ceil(timeDiff);
  return diffDays;
}
